/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    error: {
        532 : " Utilisateur introuvable",
        533 : " Aucun profil paramétré",
        adminContact : " Veuillez contacter votre administrateur"
    }
};